/* global axios */
import ApiClient from './ApiClient';

class MetaCampaignsAdsAPI extends ApiClient {
  constructor() {
    super('meta_campaigns/campaigns', { accountScoped: true });
  }

  get(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/ads`, { params });
  }
}

export default new MetaCampaignsAdsAPI();
